<template>
  <app-main-layout>
    <!--  -->
    <!-- Main Left Menu  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <!-- Main Top Menu -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-page-header
            icon="el-icon-left"
            title="Users"
            :content="count !== undefined ? `${count} Users` : ''"
          >
          </el-page-header>
        </template>
        <template v-slot:center>
          <span>
            <!-- Search -->
          </span>
        </template>
        <template v-slot:right>
          <!-- Other buttons -->
        </template>
      </app-top-nav>
    </template>
    <!--  -->
    <!-- Main Content -->
    <template v-slot:main>
      <!--  -->
      <!-- Charts -->
      <!--  -->
      <!-- Loaded users -->
      <div app-main-content>
        <UsersList :loading="loading" :users="users"></UsersList>
      </div>
    </template>
    <!--  -->
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import UsersList from "./components/users-list.component.vue";

@Options({
  components: { UsersList },
})
export default class extends Vue {
  /**
   * @returns users
   */
  get users() {
    return this.$store.state.users.users;
  }

  /**
   * @returns users
   */
  get loading() {
    return this.$store.state.users.loading;
  }

  get count() {
    return this.$store.state.users.count;
  }

  mounted() {
    this.$store.dispatch("users/fetch");
  }
}
</script>

<style lang="scss"></style>
